export default __webpack_public_path__ + "img/1d27469bb2c0ec684ef1430c286c77e7.svg";